import { render, staticRenderFns } from "./reviewer-peers-preview.component.vue?vue&type=template&id=8b963686"
import script from "./reviewer-peers-preview.component.ts?vue&type=script&lang=ts&external"
export * from "./reviewer-peers-preview.component.ts?vue&type=script&lang=ts&external"
import style0 from "./reviewer-peers-preview.component.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports